export enum DonationAmountSelection {
  Default = "Default",
  FromItem = "FromItem",
  Custom = "Custom",
}

export enum DonationFormType {
  Popup = "Popup",
  Embedded = "Embedded",
}
